import React, { Component } from "react";
import { autorun } from 'mobx';
import { inject } from 'mobx-react';
import { ANNOUNCEMENT_PAGES, REQUIRED_LOGIN_PAGE, PRESTIGE_CLUB_PAGES } from '../Foundation';
import { EVENT } from '../../common/events/listEvents';
import Utils from "../Utils";

@inject('LayoutTemplateStore', 'AccountStore')
export default function validPageChecker() {
  return (Child) => {
    return class extends Component {
      constructor(props) {
        super(props);
        this.AccountStore = this.props.AccountStore;
        this.LayoutTemplateStore = this.props.LayoutTemplateStore;

        this.checkValidPage = this.checkValidPage.bind(this);
        this.checkValidPage();
      }

      componentDidMount() {
        window.listenEvent(EVENT.CHECK_VALID_PAGE, this.checkValidPage);
        this.autorun = autorun(() => {
          this.checkValidPage();
        });
      }

      componentWillUnmount() {
        this.autorun();
        window.stopListenEvent(EVENT.CHECK_VALID_PAGE)
      }

      checkValidPage() {
        const { isValidPage, isAllowCheckValidPage } = this.LayoutTemplateStore;
        if (!isAllowCheckValidPage) return;
        const currentPage = this.props.pageContainer;
        const { isAuth } = this.AccountStore;
        const isEnableAnnouncement = Utils.isEnableAnnouncement();
        const isEnableFeatureVIP = Utils.isEnableFeatureVIP();
        let isValidCurrentPage = isValidPage;
        const isRequiredLoginPage = REQUIRED_LOGIN_PAGE.includes(currentPage);
        
        if (isRequiredLoginPage) {
          if (!isAuth) {
            isValidCurrentPage = isAuth;
          } else if (ANNOUNCEMENT_PAGES.includes(currentPage)) {
            // Hanlde checking Announcement page
            isValidCurrentPage = isEnableAnnouncement;
          } else if (PRESTIGE_CLUB_PAGES.includes(currentPage)) {
            // Hanlde checking Prestige Club page
            isValidCurrentPage = this.AccountStore.isVipAccount && isEnableFeatureVIP;
          } else {
            isValidCurrentPage = true;
          }
        } else {
          // Handle other pages which don't need logged users
          isValidCurrentPage = true;
        }
        
        if (isValidPage !== isValidCurrentPage) {
          this.LayoutTemplateStore.updateIsValidPage(isValidCurrentPage);
        }
      }

      render() {
        return (
          <Child {...this.props} />
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/decorator/validPageChecker.js